import { Navigate, useLocation } from "react-router-dom";
import { ROLE } from "./USER";

const isAuthorized = (role, path) => {
  const formattedPath = path.replace(/^\//, "");

  if (role === "Admin") {
    return true;
  } else if (
    role === "HR" &&
    ["jobs", "applications", "newjob", "editjob", "application"].includes(
      formattedPath
    )
  ) {
    return true;
  } else if (
    role === "Logistics" &&
    ["rfp", "newrfp", "editrfp"].includes(formattedPath)
  ) {
    return true;
  } else if (
    role === "Moderator" &&
    ![
      "jobs",
      "applications",
      "rfp",
      "newjob",
      "editjob",
      "application",
      "newrfp",
      "editrfp",
      "users",
    ].includes(formattedPath)
  ) {
    return true;
  } else {
    return false;
  }
};

const AuthorizedRoute = ({ children }) => {
  let location = useLocation();
  let role = ROLE();

  if (isAuthorized(role, location.pathname)) {
    return children;
  } else {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
};

export default AuthorizedRoute;
